import { useState, useEffect } from "react";
import { Users } from "lucide-react";

const BASE = 17400;
const RANGE = 600;

const LiveViewerCount = () => {
  const [count, setCount] = useState(() => BASE + Math.floor(Math.random() * RANGE));

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => {
        const delta = Math.floor(Math.random() * 31) - 15; // -15 to +15
        const next = prev + delta;
        return Math.max(BASE - 200, Math.min(BASE + RANGE + 200, next));
      });
    }, 3000 + Math.random() * 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed bottom-[70px] left-4 z-30 flex items-center gap-2 rounded-full border border-border bg-card/90 backdrop-blur-sm px-3 py-1.5 shadow-lg sm:bottom-20">
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-500 opacity-75" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-green-500" />
      </span>
      <Users className="h-3 w-3 text-muted-foreground" />
      <span className="font-mono text-xs font-semibold text-foreground">
        {count.toLocaleString()}
      </span>
      <span className="text-[10px] text-muted-foreground">online now</span>
    </div>
  );
};

export default LiveViewerCount;
